






























































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { UploaderFactory } from '../../generated';

export default Vue.extend({
  name: 'Uploader',
  watch: {
    loggedIn(loggedIn) {
      loggedIn && !this.anonymous ? this.mountUploader() : this.uploader = null;
    }
  },
  data() {
    return {
      uploader: null as any,
      dialog: false,
      uploadedFile: {
        fileNm: '',
        fileId: '',
      },
    };
  },
  computed: {
    ...mapState([
      'loggedIn',
      'anonymous',
    ])
  },
  methods: {
    onChangeInputFile(e: Event) {
      const newFile = (e.target as any).files[0] as File;
      const alert = (type: 'ok' | 'ng', msg = '') => window.alert(`${type.toUpperCase()}: ${msg}`)
      if(!newFile) return;
      this.uploadedFile = {
        fileNm: '',
        fileId: '',
      };
      this.uploader
        .upload(newFile)
        .then((res: any) => {
          this.uploadedFile = {
            fileNm: newFile.name,
            fileId: res.file_id
          };
          this.dialog = true;
          (<HTMLInputElement>this.$refs.uploader).value = '';
        })
        .catch((err: any) => {
          alert('ng', err)
        });
    },
    async mountUploader() {
      try {
        this.uploader = await UploaderFactory.create({})
      } catch(e) {
        console.error('could not creat uploader for:', e);
      }
    }
  },
});
